import React from "react";
import { Breadcrumb } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { HomeFilled, RightOutlined } from "@ant-design/icons";

const BreadCrumbs = (props) => {
  const location = props.location;
  const navigate = useNavigate();
  const pathname = location.pathname;

  // Filter out empty parts and 'node', then decode URI components
  let pathnames = pathname
    .split("/")
    .filter((part) => part !== "" && part !== "node")
    .map((e) => decodeURIComponent(e));

  const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);

  // Function to handle breadcrumb navigation
  const handleBreadcrumbClick = (clickedName, index) => {
    const currentIndex = pathnames.length - 1;
    const targetIndex = index;
    const stepsBack = currentIndex - targetIndex;

    // if (index === 0) {
    //   navigate("/");
    // } else if (stepsBack >= currentIndex) {
    //   console.log("stepsBack >= currentIndex");
    //   let newPath = "/node";
    //   for (let i = 0; i <= targetIndex; i++) {
    //     newPath += `/${pathnames[i]}`;
    //   }
    //   navigate(newPath);
    // } else {
    //   navigate(-stepsBack);
    // }
    if (index === 0) {
      navigate("/");
    } else {
      let pathArray = JSON.parse(JSON.stringify(pathnames));
      for (let i = 0; i < stepsBack; i++) {
        pathArray.pop();
      }
      navigate(`/node/${encodeURI(pathArray.join("/"))}`);
    }
  };

  // Function to handle display name for files
  const getDisplayName = (name) => {
    if (name.includes(".")) {
      return capitalize(name.substring(0, name.lastIndexOf(".")));
    }
    return capitalize(name);
  };

  return (
    <div>
      <Breadcrumb
        separator={
          <RightOutlined style={{ fontSize: "10px", color: "black" }} />
        }
        style={{ fontSize: "16px" }}
        className="mt-[30px] ml-[30px]"
      >
        {pathnames.map((name, index) => {
          const isLast = index === pathnames.length - 1;
          const displayName = getDisplayName(name);

          return isLast ? (
            <Breadcrumb.Item key={index}>
              <label
                className="mt-[-2px] pl-[5px]"
                style={{
                  fontSize: "20px",
                  fontWeight: "800",
                }}
              >
                {displayName}
              </label>
            </Breadcrumb.Item>
          ) : (
            <Breadcrumb.Item key={index}>
              <label
                className="pr-[5px]"
                style={{
                  color: "#767474",
                  fontWeight: "500",
                  cursor: "pointer",
                }}
                type="link"
                onClick={() => handleBreadcrumbClick(name, index)}
              >
                {displayName}
              </label>
            </Breadcrumb.Item>
          );
        })}
      </Breadcrumb>
    </div>
  );
};

export default BreadCrumbs;
